<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <!-- <v-tour
                name="blogisticTour"
                :steps="steps"
                :callbacks="callbacksTour"
              ></v-tour> -->
              <h4 class="card-title">Relatórios</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table">
                <div class="box-typical-body">
                  <div class="container-fluid">
                    <div class="row loadingDataPosition">
                      <div class="loadingData" v-if="loading">
                        <div class="loadingDataSpinner">
                          <spinner
                            v-if="loading"
                            text-fg-color="#ffffff"
                            message="Carregando..."
                          ></spinner>
                        </div>
                      </div>
                      <div class="container-fluid">
                        <h5>Relatório Veiculos</h5>
                        <b-row no-gutters>
                          <b-col sm="6" md="2" class="p-0">
                            <div
                              class="fl-flex-label fl-collapsed fl-background"
                            >
                              <input
                                type="text"
                                class="form-control"
                                v-model="form.placa"
                              />
                              <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                                >Placa</label
                              >
                            </div>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <div
                              class="fl-flex-label fl-collapsed fl-background"
                            >
                              <input
                                type="text"
                                class="form-control"
                                v-model="form.renavam"
                              />
                              <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                                >Renevam</label
                              >
                            </div>
                          </b-col>

                          <b-col sm="6" md="4" class="p-0">
                            <multiselect
                              v-model="transportadoraSelected"
                              :options-limit="300"
                              :limit="2"
                              :limit-text="limitText"
                              :options="optionsTransportadora"
                              track-by="value"
                              label="label"
                              id="transportadora"
                              :hide-selected="true"
                              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              :searchable="true"
                              :loading="isLoadingTransportadora"
                              @search-change="listaTransportadora"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="tipoVeiculoSelected"
                              :options="tipoVeiculoOptions"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Tipo do Veiculo"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="disponibilidadeSelected"
                              :options="optionsDisponibilidade"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Disponibilidade"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="statusSelected"
                              :options="statusOptions"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Status"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-btn
                            @click="doGerar(1)"
                            variant="secondary"
                            :disabled="isDisabled"
                          >
                            Extrair
                          </b-btn>
                          <b-btn @click="doLimpar()" variant="secondary">
                            Limpar
                          </b-btn>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import accounting from "accounting";

export default {
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      loading: false,
      isDisabled: false,
      loadingData: false,
      isFullscreen: false,
      showModal: false,
      isLoadingTransportadora: false,
      disponibilidadeSelected: "",
      transportadoraSelected: "",
      tipoVeiculoSelected: "",
      statusSelected: "",
      transportadora: [],
      optionsTransportadora: [],
      optionsTransportadora: [],
      tipoVeiculoOptions: [],
      statusOptions: [],
      optionsDisponibilidade: [
        { label: "Disponivel", value: 1 },
        { label: "Indisponivel", value: 2 },
      ],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      isLoadingTransportadora: false,
      form: new Form({
        placa: "",
        renavam: "",
        transportadora: "",
        tipo_veiculo: "",
        disponibilidade: [],
        status: "",
      }),
    };
  },
  watch: {
    transportadoraSelected(obj) {
      this.form.transportadora = obj.pessoa_id;
    },
    disponibilidadeSelected(obj) {
      this.form.disponibilidade = [obj.value];
    },
    tipoVeiculoSelected(obj) {
      this.form.tipo_veiculo = obj.value;
    },
    statusSelected(obj) {
      this.form.status = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    doGerar() {
      this.loading = true;
      this.isDisabled = true;
      if (this.form.disponibilidade.length == 0) {
        this.form.disponibilidade = [];
        this.optionsDisponibilidade.forEach((obj) => {
          this.form.disponibilidade.push(obj.value);
        });
      }
      this.form
        .post("/api/relatorio/veiculo")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    doLimpar() {
      this.form.placa = "";
      this.form.renavam = "";
      this.transportadoraSelected = "";
      this.disponibilidadeSelected = "";
      this.tipoVeiculoSelected = "";
      this.statusSelected = "";
      this.form.status = "";
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    getLivGeral() {
      this.helpForm
        .get("/api/relatorio/veiculo/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.tipo_veiculo.forEach((obj) => {
            this.tipoVeiculoOptions.push({
              label: obj.descr,
              value: obj.partipvei_id,
            });
          });
          response.status.forEach((obj) => {
            this.statusOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
